module.exports = __webpack_public_path__ + "static/media/java.33d06da6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/services/java.svg
// module id = 382
// module chunks = 0